
// Re-export everything from the new deep-analysis directory structure
// This maintains backward compatibility with existing code that imports from this file
import * as DeepAnalysisService from './deep-analysis';

// Named exports to maintain compatibility with existing import statements
export const {
  analyzePageWithOpenAI,
  logAnalysisResult,
  getApiKey,
  analyzeContent,
  testOpenAIConnection,
  runOpenAITest,
  analyzeContentWithKey
} = DeepAnalysisService;

// Also export the default for those who want to import everything
export default DeepAnalysisService;
